module.exports = __webpack_public_path__ + "static/media/approveEmployeeRequestIcon.6826a2cf.svg";